module.exports = __webpack_public_path__ + "img/hot.9a5cb4f3.png";